import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Services } from './components/Services';
import { Reviews } from './components/Reviews';
import { Commitment } from './components/Commitment';
import { Process } from './components/Process';
import { FAQ } from './components/FAQ';
import { Booking } from './components/Booking';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-amber-400/30 selection:text-white" data-id="element-0" data-mp="2mnngs5hxqe1t">
      <Navbar data-id="element-1" data-mp="31c1l6kv02akh" />
      <main data-id="element-2" data-mp="31cjp83nwlt2y">
        {/* 1. Encabezado claro: resultado, cómo lo logramos, CTA y video */}
        <Hero data-id="element-3" data-mp="2whxd1y9zzwht" />
        {/* 2. El problema que vive el cliente hoy */}
        <Problem data-id="element-4" data-mp="28suu8n3mnxlq" />
        {/* 3. La solución y qué cambia después */}
        <Services data-id="element-5" data-mp="23w4g45bdvc2y" />
        {/* 4. Las pruebas: testimonios y resultados reales */}
        <Reviews data-id="element-6" data-mp="3ik7k0rkruvvx" />
        {/* 5. Qué incluye exactamente */}
        <Commitment data-id="element-7" data-mp="3ihv22ef0kliv" />
        <Process data-id="element-8" data-mp="3mlj8gtrwtb2j" />
        {/* 6. Preguntas frecuentes */}
        <FAQ data-id="element-9" data-mp="3mjzuj9tq7c3x" />
        {/* 7. Cierre: una sola acción */}
        <Booking data-id="element-10" data-mp="3rbrakqf99zft" />
      </main>
      <Footer data-id="element-11" data-mp="3rdkg22e4udm8" />
      <StickyCTA data-id="element-12" data-mp="3rd1all5o5hp3" />
    </div>;
}